
const RFDTags = (doc, data, clinica, code) => {
    
    var RFD = doc.createElement("RFD");

	//Descripcion del Recaudo Facturado 1-Copago, 2-Cuota Moderadora, 3-Pago compartido Voluntario, 4-Anticipo, 5-No Aplica
    var RFD_1 = doc.createElement("RFD_1");
    switch (code) {
        case 1:
            RFD_1.innerHTML = "01";
            break;
        case 2:
            RFD_1.innerHTML = "02";
            break;
        case 3:
            RFD_1.innerHTML = "03";
            break;
		case 4:
            RFD_1.innerHTML = "04";
            break;
		case 5:
            RFD_1.innerHTML = "05";
            break;
        default:
            RFD_1.innerHTML = "05";
            break;
    }
    RFD.appendChild(RFD_1);

    return RFD;
}

export default RFDTags;